import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import FontBody4 from '../../../../../../../components/fonts/font-body4/font-body4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';
import { decimalFormat } from '../../../../../../../services/helpers';

interface ICalculatorLineItemProps {
    description: React.ReactNode | string;
    price: React.ReactNode | string | number;
    tax?: React.ReactNode | string | number;
    taxRate?: number;
    boldText?: boolean;
}

const CalculatorLineItem: React.FC<ICalculatorLineItemProps> = ({ boldText = false, description = "", price, tax, taxRate = 0 }) => {
    const formattedPrice = typeof price === 'number' ? Number(decimalFormat(price, 3)) : price;
    const formattedTax = typeof tax === 'number' ? Number(decimalFormat(tax, 3)) : tax;
    const formattedTaxRate = Number(decimalFormat(taxRate, 3));

    return (
        <div className="refund-calculator__line-item">
            <div className="refund-calculator__breakdown-grid">
                <div className="refund-calculator__breakdown-grid-item start">
                    <FontBody2 variant={boldText ? FONT_VARIANT.BOLD : FONT_VARIANT.DEFAULT}>{description}</FontBody2>
                </div>
                <div className="refund-calculator__breakdown-grid-item end">
                    <FontBody2 variant={boldText ? FONT_VARIANT.BOLD : FONT_VARIANT.DEFAULT}>{formattedPrice || "-"}</FontBody2>
                </div>
                <div className="refund-calculator__breakdown-grid-item end">
                    <FontBody2 variant={boldText ? FONT_VARIANT.BOLD : FONT_VARIANT.DEFAULT}>
                        {formattedTax || "-"}
                        {(formattedTax && formattedTaxRate) ? (
                            <FontBody4 variant={FONT_VARIANT.DEFAULT} color={FONT_COLOR.NEUTRAL10}>&nbsp;{formattedTaxRate}%</FontBody4>
                        ) : null}
                    </FontBody2>
                </div>
            </div>
        </div>
    );
};

export default CalculatorLineItem;
